import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import myPhoto from '../assets/photo.jpg';
import Toast from 'react-bootstrap/Toast';
import Button from 'react-bootstrap/Button';

const About = () => {
  const [showA, setShowA] = useState(true);
  const toggleShowA = () => setShowA(!showA);

  return (
    <Container className="mt-4">
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center">
          <Image src={myPhoto} thumbnail />
        </Col>
        <Col xs={12} md={8}>
          <h1>About Me</h1>
          <p>
            I'm Pilar, John Lester. from 3RD year BSCS - B 
          </p>
          <p> I do have lot of hobbies I like to do for my daily life, playing
            online games help me to cheer my day and call it great.
            Not having my career yet but I'm planning to continue What i've started years ago. </p>
          <Button onClick={toggleShowA} className="mb-2">
            Click for more.
          </Button>
          <Toast show={showA} onClose={toggleShowA}>
            <Toast.Header>
              <strong className="me-auto">Web Developer</strong>
              <small>My extra note</small>
            </Toast.Header>
            <Toast.Body>
              I specialize in front-end technologies, focusing on building interactive user interfaces.
            </Toast.Body>
          </Toast>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
